import React from "react";
import { Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell } from "@sainsburys-tech/fable";
import PropTypes from "prop-types";

const StoreSceneLevelsTable = props => (
  <div>
    <h3 className="fable:pt-4">Scene Levels</h3>
    {props.zoneSceneLevels ? (
      <Table isResponsive={true} layout="fixed">
        <TableHeader>
          <TableRow>
            <TableHeaderCell className="cb-c-overrides-list__overrides-table__name-column">Zones</TableHeaderCell>
            <TableHeaderCell>Trading</TableHeaderCell>
            <TableHeaderCell>Low Footfall</TableHeaderCell>
            <TableHeaderCell>Stocking</TableHeaderCell>
            <TableHeaderCell>Price Spike</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {props.zoneSceneLevels.map((sceneLevel, index) => (
            <TableRow key={index}>
              <TableCell className="cb-c-overrides-list__overrides-table__name-column">{sceneLevel.zoneName}</TableCell>
              <TableCell>{sceneLevel.trading}</TableCell>
              <TableCell>{sceneLevel.lowFootfall}</TableCell>
              <TableCell>{sceneLevel.stocking}</TableCell>
              <TableCell>{sceneLevel.priceSpike}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    ) : (
      <div>Scene levels have not been set for this store.</div>
    )}
  </div>
);

StoreSceneLevelsTable.propTypes = {
  zoneSceneLevels: PropTypes.arrayOf(
    PropTypes.shape({
      zoneName: PropTypes.string,
      trading: PropTypes.string,
      lowFootfall: PropTypes.string,
      stocking: PropTypes.string,
      priceSpike: PropTypes.string
    })
  )
};

export default StoreSceneLevelsTable;
